export const OLL_PCH_ERRORS = {
	// ошибки ESQ 760/770
	1: 'IGBT U  (E.out 1 )',
	2: 'IGBT V (E.out 2 )',
	3: 'IGBT W (E.out3 )',
	4: 'Перегрузка по току во время разгона (E.oc 1)',
	5: 'Перегрузка по току во время разгона (E.oc 2)',
	6: 'Перегрузка по току во время разгона (E.oc 3)',
	7: 'Повышенное напряжение во время разгона (E.ou 1)',
	8: 'Повышенное напряжение во время замедления (E.ou 2)',
	9: 'Повышенное напряжение при постоянной скорости (E.ou 3)',
	10: 'Пониженное напряжение в звене постоянного тока (E.LU)',
	11: 'Перегрузка мотора (E. ol 1 )',
	12: 'Перегрузка привода (E. ol 2 )',
	13: 'Потеря входной фазы (E.SPI )',
	14: 'Потеря выходной фазы  (E.SPO )',
	15: 'Перегрев диодного модуля  (E,OH1 )',
	16: 'Перегрев IGBT (E,OH2 )',
	17: 'Внешняя авария  (E.EF )',
	18: 'Ошибка связи RS-485 (E.CF )',
	19: 'Ошибка измерения тока (E.LCE )',
	25: 'Электронная перегрузка (E.oL3 )',
	26: 'Неисправность удаленного пульта (E.PCE )',
	27: 'Ошибка загрузки параметров (E.UPE )',
	28: 'Ошибка выгрузки параметров (E.DnE )',
	29: 'Неисправностьзаземления 1 (E.ErH1 )',
	30: 'Неисправностьзаземления 2 (E.ErH2 )',
	31: 'Ошибка отклонения заданной скорости (E.dEu)',
	32: 'Неправильная регулировка (E.STo )',
	33: 'Ошибка энкодера 1 (E.Esd1 )',
	34: 'Ошибка энкодера 2 (E.Ecd2 )',
	35: 'Перегрев мотора (E.Ptc )',
	36: 'Привод недогружен (E.LL )',
	37: 'Ошибка связи DP (E.dp )',
	38: 'Ошибка связи CAN (E.cAN )',
	
	// ошибки INSTART LCI
	39: 'Перегрузка по току при разгоне (E004)',
	40: 'Перегрузка по току при торможении или разгоне (E005)',
	41: 'Перегрузка по току при постоянной скорости (E006)',
	42: 'Превышение напряжения при разгоне (E002)',
	43: 'Превышение напряжение при торможении (E00A)',
	44: 'Превышение напряжения при постоянной скорости  (E003)',
	45: 'Пониженное напряжение на ЗПТ (E001)',
	46: 'Перегрузка двигателя (E007)',
	47: 'Перегрузка ПЧ (E008)',
	48: 'Потеря фазы на входе (E012)',
	49: 'Потеря фазы на выходе (E013)',
	50: 'Перегрев IGBT модуля (E00E)',
	51: 'Перегрузка буферного сопротивления (E014)',
	52: 'Неисправность контактора (E017)',
	53: 'Пользовательский отказ (E00D)',
	54: 'Ошибка сетевого протокола (E018)',
	55: 'Ошибка измерения тока (E015)',
	56: 'Ошибка идентификации параметров ЭД (E016)',
	57: 'Достигнуто суммарное время в состоянии работы (E020)',
	58: 'Короткое замыкание на землю (E023)',
	59: 'Перегрев двигателя (E036)',
	60: 'Некорректные параметры (E037)',
	
	// ошибки INSTART MCI/FCI
	61: 'Перегрузка по току при постоянной скорости (Err01)',
	62: 'Перегрузка по току при разгоне (Err02)',
	63: 'Перегрузка по току при замедлении (Err03)',
	64: 'Превышение напряжения при постоянной скорости (Err04)',
	65: 'Превышение напряжения при разгоне (Err05)',
	66: 'Превышение напряжения при замедлении (Err06)',
	67: 'Ошибка модуля (Err07)',
	68: 'Пониженное напряжение (Err08)',
	69: 'Перегрузка преобразователя частоты (Err09)',
	70: 'Перегрузка электродвигателя (Err10)',
	71: 'Обрыв входной фазы (Err11)',
	72: 'Обрыв выходной фазы (Err12)',
	73: 'Внешняя ошибка (Err13)',
	74: 'Нарушение обмена данными (Err14)',
	75: 'Перегрев преобразователя частоты (Err15)',
	76: 'Аппаратная неисправность преобразователя частоты (Err16)',
	77: 'Замыкание обмотки двигателя на землю (Err17)',
	78: 'Ошибка идентификации электродвигателя (Err18)',
	79: 'Холостой ход (Err19)',
	80: 'Потеря сигнала обратной связи ПИД-управления (Err20)',
	81: 'Пользовательский отказ 1 (Err21)',
	82: 'Пользовательский отказ 2 (Err22)',
	83: 'Достигнуто суммарное время включения ПЧ (Err23)',
	84: 'Достигнуто суммарное время работы ПЧ (Err24)',
	85: 'Ошибка энкодера (Err25)',
	86: 'Сбой при чтении и записи параметров (Err26)',
	87: 'Перегрев двигателя (Err27)',
	88: 'Сильное отклонение скорости (Err28)',
	89: 'Превышение скорости двигателя (Err29)',
	90: 'Ошибка начального положения (Err30)',
	91: 'Отказ прохождения теста (Err31)',
	92: 'Контактор (Err32)',
	93: 'Ошибка прохождения теста (Err33)',
	94: 'Превышено время Тайм-аута (Err34)',
	95: 'Переключения двигателя во время работы (Err35)',
	96: 'Отказ питания 24 В (Err36)',
	97: 'Неисправность источника питания (Err37)',
	98: 'Резерв (Err38)',
	99: 'Резерв (Err39)',
	100: 'Ошибка буферизации (Err40)',

    // ... можно добавить остальные 200 ошибок
    200: 'Неизвестная ошибка'
};

export const getOllPchError = (errorCode) => {
    if (!errorCode || errorCode === 0) return '';
    return OLL_PCH_ERRORS[errorCode];
};

export const Instart_PCH_ERRORS = {
    0: 'Нет ошибок',
};

export const getPchInstartError = (errorCode) => {
    if (!errorCode || errorCode === '0') return '';
    return Instart_PCH_ERRORS[errorCode] || `Ошибка (${errorCode.toString().padStart(2, '0')})`;
};

export const ESQ_PCH_ERRORS = {
    1: 'IGBT U  (E.out 1 )',
	2: 'IGBT V (E.out 2 )',
	3: 'IGBT W (E.out3 )',
	4: 'Перегрузка по току во время разгона (E.oc 1)',
	5: 'Перегрузка по току во время разгона (E.oc 2)',
	6: 'Перегрузка по току во время разгона (E.oc 3)',
	7: 'Повышенное напряжение во время разгона (E.ou 1)',
	8: 'Повышенное напряжение во время замедления (E.ou 2)',
	9: 'Повышенное напряжение при постоянной скорости (E.ou 3)',
	10: 'Пониженное напряжение в звене постоянного тока (E.LU)',
	11: 'Перегрузка мотора (E. ol 1 )',
	12: 'Перегрузка привода (E. ol 2 )',
	13: 'Потеря входной фазы (E.SPI )',
	14: 'Потеря выходной фазы  (E.SPO )',
	15: 'Перегрев диодного модуля  (E,OH1 )',
	16: 'Перегрев IGBT (E,OH2 )',
	17: 'Внешняя авария  (E.EF )',
	18: 'Ошибка связи RS-485 (E.CF )',
	19: 'Ошибка измерения тока (E.LCE )',
	25: 'Электронная перегрузка (E.oL3 )',
	26: 'Неисправность удаленного пульта (E.PCE )',
	27: 'Ошибка загрузки параметров (E.UPE )',
	28: 'Ошибка выгрузки параметров (E.DnE )',
	29: 'Неисправностьзаземления 1 (E.ErH1 )',
	30: 'Неисправностьзаземления 2 (E.ErH2 )',
	31: 'Ошибка отклонения заданной скорости (E.dEu)',
	32: 'Неправильная регулировка (E.STo )',
	33: 'Ошибка энкодера 1 (E.Esd1 )',
	34: 'Ошибка энкодера 2 (E.Ecd2 )',
	35: 'Перегрев мотора (E.Ptc )',
	36: 'Привод недогружен (E.LL )',
	37: 'Ошибка связи DP (E.dp )',
	38: 'Ошибка связи CAN (E.cAN )',
};

export const getPchEsqError = (errorCode) => {
    if (!errorCode || errorCode === '0') return '';
    return ESQ_PCH_ERRORS[errorCode] || `Ошибка (Err${errorCode.toString().padStart(2, '0')})`;
};

export const ATV_PCH_ERRORS = {
    0: 'Ошибка',
};

export const getPchAtvError = (errorCode) => {
    if (!errorCode || errorCode === '0') return '';
    return ATV_PCH_ERRORS[errorCode] || `Ошибка (${errorCode.toString().padStart(2, '0')})`;
};


